import {
  FETCH_LEDGER_SUCCESS,
  FETCH_LEDGER_FAIL,
  FETCH_DAILY_LEDGER_SUCCESS,
  FETCH_DAILY_LEDGER_FAIL,
} from '../actions/types';

const initialState = {
  ledger: [],
  daily: [],
  pagination: [],
  errors: [],
  success: [],
};

const ledger = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEDGER_SUCCESS:
      return {
        ...state,
        ledger: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_LEDGER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_DAILY_LEDGER_SUCCESS:
      return {
        ...state,
        daily: action.payload.data,
        loading: false,
      };
    case FETCH_DAILY_LEDGER_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default ledger;
